var map = {
	"./404.svg": "sEM+",
	"./account.svg": "lNpt",
	"./alarm.svg": "mMjV",
	"./amount.svg": "yTd3",
	"./backup-device.svg": "tECQ",
	"./big-data.svg": "O++4",
	"./bind.svg": "17vA",
	"./blokenLink.svg": "DlWm",
	"./bug.svg": "SVqS",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./cloud-download.svg": "pgGC",
	"./column-configuration.svg": "0dFg",
	"./component.svg": "s2cW",
	"./configuration-management.svg": "3Ml+",
	"./dashboard.svg": "BCGP",
	"./data-cube.svg": "ZmdN",
	"./data-statistics.svg": "HoT7",
	"./data.svg": "RUrO",
	"./device.svg": "k6Cd",
	"./diamonds.svg": "Itmm",
	"./documentation.svg": "zUKd",
	"./download.svg": "+H2/",
	"./drag.svg": "vRhf",
	"./edit.svg": "ql+d",
	"./email.svg": "+4G4",
	"./equipment-facilities.svg": "aiXt",
	"./equity-allocation.svg": "aS0Q",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./eye.svg": "4wdf",
	"./file.svg": "fQ0v",
	"./form.svg": "sTIr",
	"./formula.svg": "IL+O",
	"./guide 2.svg": "kA1i",
	"./guide.svg": "z74U",
	"./icon.svg": "vUvT",
	"./input.svg": "k6mQ",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./link.svg": "KgwQ",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./machine.svg": "ocTq",
	"./machine_model.svg": "di+Z",
	"./maintain.svg": "YWMt",
	"./maintenance-plan.svg": "VzCX",
	"./materiel.svg": "8lbs",
	"./merchant-management.svg": "+FEl",
	"./merchant.svg": "8OX1",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./nested.svg": "798r",
	"./offline.svg": "eGXv",
	"./online.svg": "lWBX",
	"./operation.svg": "Dh6m",
	"./organization.svg": "Jost",
	"./paper-cup.svg": "nXB4",
	"./password.svg": "QjmH",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./personnel.svg": "QtbL",
	"./pieChart.svg": "agSB",
	"./plan.svg": "0Ex+",
	"./produce_import.svg": "52fm",
	"./produce_parmas.svg": "yD0d",
	"./product.svg": "UHi4",
	"./qq.svg": "R2jY",
	"./refresh.svg": "SLu3",
	"./role.svg": "cqqK",
	"./service.svg": "nCjf",
	"./setting.svg": "Kttn",
	"./shop.svg": "hert",
	"./shopping.svg": "jRi0",
	"./size.svg": "Cr4N",
	"./software-upgrade.svg": "b5Gq",
	"./star.svg": "60zo",
	"./sys.svg": "zQA3",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./tip.svg": "6+87",
	"./tree.svg": "3eCm",
	"./upload.svg": "P/TB",
	"./user.svg": "VdD3",
	"./wechat.svg": "pYJ+",
	"./workOrder.svg": "PAHi",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 375